import api from "./client"

export function getArticles(page = 1, perPage = 12) {
  return api.get(`/api/articles?populate=image,author&pagination[page]=${page}&pagination[pageSize]=${perPage}&sort[0]=createdAt:desc`)
}

export function getSingleArticle(id) {
  return api.get(`/api/articles/${id}?populate=image,author`)
}

export function getTestimonials(page = 1, perPage = 12) {
  return api.get(`/api/testimonials?populate=image&pagination[page]=${page}&pagination[pageSize]=${perPage}&sort[0]=createdAt:desc`)
}

export function getRecentArticles(page = 1, perPage = 12) {
  return api.get(`/api/articles?populate=image,author&pagination[page]=${page}&pagination[pageSize]=${perPage}&sort[0]=createdAt:desc`)
}

export function getCategories(page = 1, perPage = 12) {
  return api.get(`/api/categories?pagination[page]=${page}&pagination[pageSize]=${perPage}`)
}

export function getSingleCategory(id) {
  return api.get(`/api/categories/${id}`)
}

export function getSingleCategoryArticles(slug, page = 1, perPage = 12) {
  return api.get(`/api/articles?populate=image,author&filters[category][slug][$eq]=${slug}&pagination[page]=${page}&pagination[pageSize]=${perPage}&sort[0]=createdAt:desc`)
}

export const iskibrisstrapi = { getSingleCategoryArticles, getArticles, getSingleArticle, getTestimonials, getCategories, getRecentArticles, getSingleCategory }